<ng-container *ngIf="state$ | async as state" [ngSwitch]="state.kind">
  <iframe
    *ngSwitchCase="'arena'"
    class="mu_chat__frame"
    [src]="$any(state).url"
    [title]="'shared.chatPanelTitle' | translate"
    referrerpolicy="no-referrer"
  ></iframe>
  <app-mu-chat-launcher *ngSwitchCase="'launcher'" (pressed)="chat.launcherPressed()"></app-mu-chat-launcher>
  <app-mu-chat-country-selector
    *ngSwitchCase="'selector'"
    (selected)="chat.countrySelected($event)"
    (dismissed)="chat.selectorDismissed()"
  ></app-mu-chat-country-selector>
</ng-container>
